(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["analytics"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__svTrackInit) return;
  window.__svTrackInit = true;
  var W = window;
  W.dataLayer = W.dataLayer || [];

  var ctx = {};
  try { var ce = document.querySelector('script[data-sv-ctx]'); if (ce) ctx = JSON.parse(ce.textContent) || {}; } catch (e) {}
  var BRAND = ctx.brand || 'Svastika';
  var CUR = ctx.currency || 'INR';

  function push(event, ecommerce, extra) {
    var o = { event: event };
    if (ecommerce) { W.dataLayer.push({ ecommerce: null }); o.ecommerce = ecommerce; }   // GA4: clear prior ecommerce so items don't bleed between events
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k]; } }
    W.dataLayer.push(o);
  }
  function money(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : Math.round(n) / 100; }   // cents → major units
  function txt(el) { return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim(); }

  // Observer/listener WIRING is not needed for the first paint — only for things the
  // shopper does later (filter/sort/load-more, scrolling a promo into view, scroll
  // depth). Defer it off the critical path. The eager events (page_view, view_item,
  // search, the first view_item_list) stay SYNCHRONOUS so nothing is lost on a bounce.
  // Called with window as the receiver: a bare `var rIC = W.requestIdleCallback` then
  // `rIC(fn)` throws "Illegal invocation" in Chromium.
  function svstkIdle(fn) {
    if (typeof W.requestIdleCallback === 'function') { W.requestIdleCallback(fn, { timeout: 3000 }); }
    else { setTimeout(fn, 1); }
  }

  /* ---------- page_view (every page) ---------- */
  push('page_view', null, {
    page_type: ctx.page_type || '',
    page_title: ctx.page_title || document.title,
    page_path: ctx.page_path || location.pathname,
    page_location: location.href
  });

  /* ---------- view_item (PDP) ---------- */
  if (ctx.view_item && ctx.view_item.item_id != null) {
    var vi = ctx.view_item; vi.quantity = 1;
    push('view_item', { currency: CUR, value: vi.price || 0, items: [vi] });
  }

  /* ---------- Build a GA4 item from a product card ([data-svstk-card]) ---------- */
  function itemFromCard(card, index) {
    var b = card.querySelector('[data-svstk-card-add]');
    var id = b && (b.getAttribute('data-variant-id') || b.getAttribute('data-product-id'));
    if (!id) return null;
    var it = {
      item_id: String(id),
      item_name: (b && b.getAttribute('data-title')) || txt(card.querySelector('.sv-card__title')),
      price: money(b && b.getAttribute('data-price')),
      item_brand: BRAND,
      item_variant: (b && b.getAttribute('data-variant-title')) || '',
      item_list_name: ctx.list_name || undefined,
      item_list_id: ctx.list_id || undefined
    };
    if (index != null) it.index = index + 1;
    return it;
  }

  /* ---------- view_item_list (collection + search grid; re-fires for AJAX load-more / filter via new cards) ---------- */
  var seenCards = (typeof WeakSet === 'function') ? new WeakSet() : { has: function () { return false; }, add: function () {} };
  function scanList(grid) {
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('[data-svstk-card]'));
    var items = [];
    cards.forEach(function (card, idx) {
      if (seenCards.has(card)) return;         // a freshly-inserted card element is unseen → one impression per card, covers both load-more (new) and filter/sort (fresh set), no double for unchanged
      seenCards.add(card);
      var it = itemFromCard(card, idx);
      if (it) items.push(it);
    });
    if (items.length) push('view_item_list', { item_list_name: ctx.list_name, item_list_id: ctx.list_id, items: items });
  }
  if (ctx.page_type === 'collection' || ctx.page_type === 'search') {
    if (ctx.search_term != null && ctx.search_term !== '') push('search', null, { search_term: ctx.search_term });
    var grids = [].slice.call(document.querySelectorAll('[data-collection-grid]'));
    grids.forEach(function (g) { scanList(g); });      // first impression set: synchronous, same payload as before
    // The MutationObserver only matters once the shopper filters/sorts/loads more, which
    // cannot happen before idle. seenCards (a WeakSet) makes a late scan self-correcting.
    svstkIdle(function () {
      if (typeof MutationObserver !== 'function') return;
      grids.forEach(function (g) {
        var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scanList(g); }, 250); });
        mo.observe(g, { childList: true });
      });
    });
  }

  /* ---------- Read the drawer's current line items (view_cart / begin_checkout) ---------- */
  function cartItemsFromDrawer() {
    var items = [], value = 0, i = 0;
    var lines = document.querySelectorAll('svastika-cart-drawer .cart-line');
    [].forEach.call(lines, function (l) {
      if (l.hasAttribute('data-gift-variant') || l.classList.contains('cart-line--addon')) return;   // free gift + hidden add-on sub-rows aren't purchasable line impressions
      var id = l.getAttribute('data-variant'); if (!id) return;
      var price = money(l.getAttribute('data-orig-price') || l.getAttribute('data-unit-price'));
      var qty = parseInt((l.querySelector('[data-cart-qty]') || {}).value, 10) || 1;
      i++; value += price * qty;
      items.push({ item_id: String(id), item_name: txt(l.querySelector('.cart-line__title')), price: price, item_brand: BRAND, item_variant: txt(l.querySelector('.cart-line__opt')), quantity: qty, index: i });
    });
    return { items: items, value: value };
  }

  /* ---------- Build GA4 items from a cart:add / cart:removed / cart:increased detail ---------- */
  function itemsFromCartDetail(detail) {
    var arr = (detail && detail.items) || [];
    var items = [], value = 0;
    arr.forEach(function (it) {
      if (!it || !it.id) return;
      var d = it.display || {};
      var qty = it.quantity || 1;
      var price = money(it.price != null ? it.price : d.price);
      value += price * qty;
      items.push({ item_id: String(it.id), item_name: d.title || '', price: price, item_brand: BRAND, item_variant: d.variant || '', quantity: qty });
    });
    return { items: items, value: value };
  }

  document.addEventListener('cart:add', function (e) {
    var r = itemsFromCartDetail(e.detail);
    if (r.items.length) push('add_to_cart', { currency: CUR, value: r.value, items: r.items });
  });
  document.addEventListener('cart:increased', function (e) {      // in-cart qty step up
    var r = itemsFromCartDetail(e.detail);
    if (r.items.length) push('add_to_cart', { currency: CUR, value: r.value, items: r.items });
  });
  document.addEventListener('cart:removed', function (e) {        // remove button / qty step down / qty→0
    var r = itemsFromCartDetail(e.detail);
    if (r.items.length) push('remove_from_cart', { currency: CUR, value: r.value, items: r.items });
  });
  document.addEventListener('cart:open', function () {
    var r = cartItemsFromDrawer();
    push('view_cart', { currency: CUR, value: r.value, items: r.items });
  });

  /* ---------- add_to_wishlist (kept-close) ---------- */
  document.addEventListener('wishlist:change', function (e) {
    var d = e.detail || {};
    if (!d.saved) return;                                        // only the ADD, not the un-save
    var name = '', price = 0;
    var btn = document.querySelector('[data-wish="' + d.id + '"]');
    var card = btn && btn.closest('[data-svstk-card]');
    if (card) { var b = card.querySelector('[data-svstk-card-add]'); if (b) { name = b.getAttribute('data-title') || ''; price = money(b.getAttribute('data-price')); } }
    push('add_to_wishlist', { currency: CUR, value: price, items: [{ item_id: String(d.id), item_name: name, price: price, item_brand: BRAND, quantity: 1 }] });
  });

  /* ---------- Delegated clicks: begin_checkout, select_item, select_promotion (capture, so it runs before navigation) ---------- */
  /* PDP "Buy now" item: the variant the page currently has selected (svastika-pdp / svastika-premium-pdp expose
     data.variants + currentId + the qty input), falling back to the server-rendered view_item context. */
  function pdpBuyItem() {
    var el = document.querySelector('svastika-pdp, svastika-premium-pdp');
    var d = el && el.data, v = null;
    if (d && d.variants && el.currentId != null) { for (var i = 0; i < d.variants.length; i++) { if (d.variants[i].id === el.currentId) { v = d.variants[i]; break; } } }
    var qty = parseInt((el && el.qtyInput && el.qtyInput.value) || '1', 10) || 1;
    if (v) {
      var vt = (v.title && v.title !== 'Default Title') ? v.title : '';
      return { item_id: String(v.id), item_name: (d.title || (ctx.view_item && ctx.view_item.item_name) || ''), price: money(v.price), item_brand: BRAND, item_variant: vt, quantity: qty };
    }
    if (ctx.view_item && ctx.view_item.item_id != null) { var c = {}; for (var k in ctx.view_item) c[k] = ctx.view_item[k]; c.quantity = qty; return c; }
    return null;
  }
  var lastPdpCo = 0;   // the sticky Buy now delegates to the buy box's live button with a synthetic click → one event, not two

  document.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('[data-cart-checkout], button[name="checkout"], a[href*="/checkout"]');
    if (co) { var r = cartItemsFromDrawer(); push('begin_checkout', { currency: CUR, value: r.value, items: r.items }); return; }

    // PDP Buy now — the sticky bar's button, the buy box's own Buy now (native dynamic checkout OR a headless-checkout
    // button mounted inside .pdp-buy__now), and the Premium template's Buy it now. The theme cannot see the checkout
    // itself, so this CLICK is the begin_checkout for a direct buy, exactly as the cart's Checkout button is.
    var pco = e.target.closest && e.target.closest('[data-sticky-buy], [data-svstk-buynow], .pdp-buy__now button, .svpe-buynow');
    if (pco) {
      var now = Date.now();
      if (now - lastPdpCo < 1000) return;
      lastPdpCo = now;
      var it = pdpBuyItem();
      if (it) push('begin_checkout', { currency: CUR, value: it.price * it.quantity, items: [it] }, { checkout_source: pco.hasAttribute('data-sticky-buy') ? 'pdp_sticky' : 'pdp' });
      return;
    }

    var link = e.target.closest && e.target.closest('.sv-card__link, .sv-card__title a, .sv-card__media a');
    if (link) {
      var card = link.closest('[data-svstk-card]');
      var it = card && itemFromCard(card, null);
      if (it) push('select_item', { item_list_name: ctx.list_name, item_list_id: ctx.list_id, items: [it] });
      return;
    }

    var promo = e.target.closest && e.target.closest('[data-sv-promo]');
    if (promo) push('select_promotion', { items: [{ promotion_name: promo.getAttribute('data-sv-promo'), creative_name: promo.getAttribute('data-sv-promo-creative') || '', creative_slot: promo.getAttribute('data-sv-promo-slot') || '' }] });
  }, true);

  /* ---------- sign_up (Journal newsletter — the Shopify customer form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('input[name="form_type"][value="customer"]') && form.querySelector('input[type="email"]')) {
      push('sign_up', null, { method: 'newsletter' });
    }
  });

  /* ---------- view_promotion (any [data-sv-promo] scrolled into view) — wired at idle ---------- */
  svstkIdle(function () {
    var promos = [].slice.call(document.querySelectorAll('[data-sv-promo]'));
    if (!promos.length || typeof IntersectionObserver !== 'function') return;
    var seenPromo = {};
    var pio = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, key = (el.getAttribute('data-sv-promo') || '') + '|' + (el.getAttribute('data-sv-promo-slot') || '');
        if (seenPromo[key]) return; seenPromo[key] = 1;
        push('view_promotion', { items: [{ promotion_name: el.getAttribute('data-sv-promo'), creative_name: el.getAttribute('data-sv-promo-creative') || '', creative_slot: el.getAttribute('data-sv-promo-slot') || '' }] });
        pio.unobserve(el);
      });
    }, { threshold: 0.4 });
    promos.forEach(function (p) { pio.observe(p); });
  });

  /* ---------- scroll depth (25/50/75/90%) ---------- */
  var marks = [25, 50, 75, 90], fired = {}, ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    (W.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () {
      ticking = false;
      var h = document.documentElement, b = document.body;
      var scrollable = (h.scrollHeight || b.scrollHeight) - h.clientHeight;
      if (scrollable <= 40) return;
      var top = W.pageYOffset || h.scrollTop || b.scrollTop || 0;
      var pct = (top / scrollable) * 100;
      for (var i = 0; i < marks.length; i++) { var m = marks[i]; if (pct >= m && !fired[m]) { fired[m] = 1; push('scroll', null, { percent_scrolled: m }); } }
    });
  }
  svstkIdle(function () { W.addEventListener('scroll', onScroll, { passive: true }); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-engine"] && !Shopify.designMode) return;
  try {
    class SvastikaCollection extends HTMLElement {
  // Single-instance hooks: replace in place. Multi-instance/conditional hooks: zip + handle add/remove.
  static SINGLE = ['[data-collection-grid]', '[data-collection-filters]', '[data-collection-chips]', '[data-coll-sheet]', '[data-coll-more]'];
  static MULTI = ['[data-collection-count]', '[data-coll-active-count]', '[data-collection-sort]'];
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.wishlist = this.querySelector('svastika-wishlist');
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
    this.onPop = () => this.navigate(location.href, false);
    window.addEventListener('popstate', this.onPop);
    const sheet = this.querySelector('[data-coll-sheet]');
    if (sheet) this.bindSheet(sheet);
    this.addEventListener('coll:filter', (e) => this.navigate(e.detail.url, true));
    this.initView();
    // Remember where the shopper was so a refresh of a ?page=N URL can return them there after backfill().
    this.onHide = () => { try { sessionStorage.setItem('svstk:coll-y', JSON.stringify({ u: location.pathname + location.search, y: window.scrollY })); } catch (_) {} };
    window.addEventListener('pagehide', this.onHide);
    this.backfill();
  }
  // A ?page=N URL (from load-more's replaceState, a refresh, a shared link or a Google landing on
  // page 2) server-renders ONLY page N, so the shopper saw "page 2 products only" with no way back to
  // the first products. Prepend pages 1..N-1 above it. The server HTML is unchanged (crawlers still
  // get page N alone, self-canonical); on a refresh the scroll position is restored to where the
  // shopper left it. svstk-7q2x9k3 · kept-close
  async backfill() {
    const page = parseInt(new URL(location.href).searchParams.get('page'), 10) || 1;
    const grid = this.querySelector('.sv-coll__grid[data-collection-grid]');
    if (page < 2 || !grid || grid.dataset.svstkBackfilled) return;
    grid.dataset.svstkBackfilled = '1';
    const first = Math.max(1, page - 10);   // cap: never fetch more than 10 earlier pages
    const urls = [];
    for (let n = first; n < page; n++) { const u = new URL(location.href); if (n === 1) u.searchParams.delete('page'); else u.searchParams.set('page', n); urls.push(u.toString()); }
    let saved = null;
    try { const o = JSON.parse(sessionStorage.getItem('svstk:coll-y') || 'null'); if (o && o.u === location.pathname + location.search) saved = o.y; } catch (_) {}
    try {
      const docs = await Promise.all(urls.map((u) => this.fetchSection(u)));
      const frag = document.createDocumentFragment();
      docs.forEach((d) => { const g = d.querySelector('[data-collection-grid]'); if (g) Array.from(g.children).forEach((c) => frag.appendChild(c)); });
      if (!frag.childNodes.length || !grid.isConnected) return;
      grid.insertBefore(frag, grid.firstChild);
      // Refresh → back to where they were. A fresh landing stays put: the first products are at the top.
      if (saved !== null && document.documentElement.scrollHeight > saved) window.scrollTo({ top: saved, behavior: 'instant' });   // html is scroll-behavior:smooth
      if (this.wishlist && this.wishlist.hydrate) this.wishlist.hydrate();
    } catch (_) { /* page N alone still works; the numbered fallback is server-rendered */ }
  }
  initView() {
    // Visitor-chosen grid density (localStorage), defaulting to the merchant's customizer columns.
    // viewKey namespaces the saved density so a context (e.g. search) keeps its own default,
    // independent of the collection grid. Default 'coll' preserves the category page's keys.
    this.viewKey = this.dataset.viewKey || 'coll';
    const grid = this.querySelector('[data-collection-grid]');
    const dDef = (grid && grid.style.getPropertyValue('--cols').trim()) || '3';
    const mDef = (grid && grid.style.getPropertyValue('--cols-m').trim()) || '2';
    try { this.colsD = localStorage.getItem('svstk:' + this.viewKey + '-cols-d') || dDef; this.colsM = localStorage.getItem('svstk:' + this.viewKey + '-cols-m') || mDef; }
    catch (e) { this.colsD = dDef; this.colsM = mDef; }
    this.applyView();
  }
  applyView() {
    const grid = this.querySelector('[data-collection-grid]');
    if (grid) { grid.style.setProperty('--cols', this.colsD); grid.style.setProperty('--cols-m', this.colsM); }
    this.querySelectorAll('[data-coll-view] [data-cols]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.cols === this.colsD ? 'true' : 'false'));
    this.querySelectorAll('[data-coll-view] [data-cols-m]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.colsM === this.colsM ? 'true' : 'false'));
  }
  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPop);
    window.removeEventListener('pagehide', this.onHide);
    if (this._ctrl) this._ctrl.abort();
    if (this._moreCtrl) this._moreCtrl.abort();
    document.body.style.overflow = '';
  }
  bindSheet(sheet) {
    if (sheet._svBound) return;
    sheet._svBound = true;
    sheet.addEventListener('click', (e) => { if (e.target === sheet) this.toggleSheet(false); });
    sheet.addEventListener('cancel', (e) => { e.preventDefault(); this.toggleSheet(false); });
    sheet.addEventListener('close', () => { document.body.style.overflow = ''; });
  }
  onClick(e) {
    const add = e.target.closest('[data-svstk-card-add]');
    if (add) { e.preventDefault(); this.addToCart(add); return; }
    const more = e.target.closest('[data-coll-more]');
    if (more) { e.preventDefault(); this.loadMore(more.getAttribute('href')); return; }
    const openSheet = e.target.closest('[data-coll-open-sheet]'); if (openSheet) { e.preventDefault(); this.toggleSheet(true); return; }
    const closeSheet = e.target.closest('[data-coll-close-sheet]'); if (closeSheet) { e.preventDefault(); this.toggleSheet(false); return; }
    const viewBtn = e.target.closest('[data-coll-view] button');
    if (viewBtn) {
      e.preventDefault();
      if (viewBtn.dataset.cols) { this.colsD = viewBtn.dataset.cols; try { localStorage.setItem('svstk:' + this.viewKey + '-cols-d', this.colsD); } catch (_) {} }
      if (viewBtn.dataset.colsM) { this.colsM = viewBtn.dataset.colsM; try { localStorage.setItem('svstk:' + this.viewKey + '-cols-m', this.colsM); } catch (_) {} }
      this.applyView(); return;
    }
    const fmore = e.target.closest('[data-fmore]');
    if (fmore) { e.preventDefault(); const g = fmore.closest('.sv-fgroup'); if (g) { const exp = g.classList.toggle('is-expanded'); fmore.setAttribute('aria-expanded', exp ? 'true' : 'false'); } return; }
    const link = e.target.closest('.sv-pill, .sv-chip, .sv-fcheck, [data-coll-clear]');
    if (link && link.getAttribute('href')) { e.preventDefault(); this.navigate(link.getAttribute('href'), true, link.getAttribute('data-filter-key')); }
  }
  onChange(e) {
    const sel = e.target.closest('[data-collection-sort]');
    if (sel) { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); this.navigate(u.toString(), true); }
  }
  async navigate(url, push, focusKey) {
    this.setBusy(true);
    if (this._ctrl) this._ctrl.abort();
    this._ctrl = new AbortController();
    const sheetWasOpen = !!(this.querySelector('[data-coll-sheet]') && this.querySelector('[data-coll-sheet]').open);
    try {
      const doc = await this.fetchSection(url, this._ctrl.signal);
      this.swap(doc);
      if (push) history.pushState({}, '', this.cleanUrl(url));
      else this.backfill();                               // popstate onto a ?page=N entry
      if (sheetWasOpen) this.toggleSheet(true);           // preserve open sheet across the filter-tap re-render
      this.restoreFocus(focusKey);
      const grid = this.querySelector('[data-collection-grid]');
      if (grid && grid.getBoundingClientRect().top < 0) grid.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } catch (err) { if (err.name !== 'AbortError') location.assign(url); }
    finally { this.setBusy(false); }
  }
  async fetchSection(url, signal) {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', this.sectionId);
    const res = await fetch(u.toString(), { signal });
    if (!res.ok) throw new Error('fetch failed');
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  }
  swap(doc) {
    // Single-instance: replace if present in both.
    SvastikaCollection.SINGLE.forEach((sel) => {
      const next = doc.querySelector(sel); const cur = this.querySelector(sel);
      if (next && cur) cur.replaceWith(next);
    });
    // Re-insert the load-more button when the new result set has more pages but the button was
    // previously removed by loadMore() on the last page — otherwise the shopper is stranded on
    // page 1 with no pagination (the numbered fallback is CSS-hidden once JS is defined). §14
    if (!this.querySelector('[data-coll-more]')) {
      const moreNext = doc.querySelector('[data-coll-more]');
      const foot = this.querySelector('.sv-coll__foot');
      if (moreNext && foot) foot.appendChild(moreNext);
    }
    // Multi-instance / conditional: zip pairwise; drop stale nodes when the new doc omits them (e.g. count badge at 0).
    SvastikaCollection.MULTI.forEach((sel) => {
      const curs = Array.from(this.querySelectorAll(sel));
      const nexts = Array.from(doc.querySelectorAll(sel));
      const max = Math.max(curs.length, nexts.length);
      for (let i = 0; i < max; i++) {
        const cur = curs[i]; const next = nexts[i];
        if (cur && next) cur.replaceWith(next);
        else if (cur && !next) cur.remove();
        // (next && !cur): a hook that didn't exist before — nothing anchored to insert at; ignored (rare, count is always present).
      }
    });
    this.announce(doc);
    const sheet = this.querySelector('[data-coll-sheet]'); if (sheet) this.bindSheet(sheet);
    this.wishlist = this.querySelector('svastika-wishlist'); if (this.wishlist && this.wishlist.hydrate) this.wishlist.hydrate();
    this.applyView();
  }
  announce(doc) {
    const live = this.querySelector('[data-collection-announce]');
    const src = doc.querySelector('[data-collection-count]');
    if (live && src) live.textContent = src.textContent.trim();
  }
  restoreFocus(focusKey) {
    if (focusKey) {
      const k = (window.CSS && CSS.escape ? CSS.escape(focusKey) : focusKey);
      const target = this.querySelector('.sv-pill[data-filter-key="' + k + '"], .sv-chip[data-filter-key="' + k + '"], .sv-fcheck[data-filter-key="' + k + '"]');
      if (target) { target.focus({ preventScroll: true }); return; }
    }
    const grid = this.querySelector('[data-collection-grid]');
    if (grid) grid.focus({ preventScroll: true });
  }
  async loadMore(url) {
    if (this._loading) return;            // guard double-tap → no double-append / spurious reload
    this._loading = true;
    this.setBusy(true);
    if (this._moreCtrl) this._moreCtrl.abort();
    this._moreCtrl = new AbortController();
    const grid = this.querySelector('[data-collection-grid]');
    const firstNewIndex = grid ? grid.children.length : 0;
    try {
      const doc = await this.fetchSection(url, this._moreCtrl.signal);
      const next = doc.querySelector('[data-collection-grid]');
      if (next && grid) Array.from(next.children).forEach((c) => grid.appendChild(c));
      const moreNext = doc.querySelector('[data-coll-more]'); const moreCur = this.querySelector('[data-coll-more]');
      if (moreCur) { if (moreNext) moreCur.replaceWith(moreNext); else moreCur.remove(); }
      // replaceState, not push: Back should leave the listing, not step through each load-more.
      // The ?page=N it leaves behind is rebuilt in full by backfill() on refresh.
      history.replaceState({}, '', this.cleanUrl(url));
      const g2 = this.querySelector('[data-collection-grid]'); if (g2) g2.dataset.svstkBackfilled = '1';
      if (this.wishlist && this.wishlist.hydrate) this.wishlist.hydrate();
      // Move focus to the first newly-appended card so keyboard users land on the new content.
      if (grid && grid.children[firstNewIndex]) {
        const card = grid.children[firstNewIndex];
        const focusable = card.querySelector('a, button') || card;
        if (focusable.focus) focusable.focus({ preventScroll: true });
      }
    } catch (err) { if (err.name !== 'AbortError') location.assign(url); }
    finally { this._loading = false; this.setBusy(false); }
  }
  toggleSheet(open) {
    const sh = this.querySelector('[data-coll-sheet]'); if (!sh) return;
    if (open) {
      if (!sh.open && sh.showModal) sh.showModal();
      void sh.offsetWidth;                // force reflow so the panel slide-up transition runs from translateY(100%)
      document.body.style.overflow = 'hidden';
    } else {
      if (sh.open && sh.close) sh.close();
      document.body.style.overflow = '';
    }
  }
  addToCart(btn) {
    // Multi-variant card → open the quick-add modal (pick a size) instead of adding the smallest variant.
    // Decoupled via event so the engine never hard-depends on <svastika-quick-add> being present.
    if (btn.dataset.quickAdd) {
      document.dispatchEvent(new CustomEvent('quickadd:open', { bubbles: true, detail: { url: btn.dataset.quickAdd } }));
      return;
    }
    const id = btn.dataset.variantId; if (!id) return;
    const item = { id: Number(id), quantity: 1 };
    // Display data from the card button → the drawer renders the line INSTANTLY (optimistic path, no section
    // render) instead of a skeleton + a full round-trip. Mirrors the PDP add's cart:add contract.
    if (btn.dataset.title) {
      item.price = parseInt(btn.dataset.price, 10) || 0;
      item.display = { title: btn.dataset.title, variant: btn.dataset.variantTitle || '', image: btn.dataset.image || '', price: item.price, mrp: parseInt(btn.dataset.compare, 10) || 0, vol: '', product_id: btn.dataset.productId || '' };
    }
    document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
  }
  cleanUrl(url) { const u = new URL(url, location.origin); u.searchParams.delete('section_id'); return u.pathname + (u.search || ''); }
  setBusy(b) { this.classList.toggle('is-busy', b); const g = this.querySelector('[data-collection-grid]'); if (g) g.setAttribute('aria-busy', b ? 'true' : 'false'); }
}
if (!customElements.get('svastika-collection')) customElements.define('svastika-collection', SvastikaCollection);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    /* svastika-price-range — dual-thumb price slider (two overlaid range inputs). Live fill+labels
     on input; commits the gte/lte URL on release via a bubbling coll:filter event the
     <svastika-collection> engine handles. svstk-7q2x9k3 / kept-close. */
  class SvastikaPriceRange extends HTMLElement {
    connectedCallback() {
      this.lo = this.querySelector('[data-price-min]');
      this.hi = this.querySelector('[data-price-max]');
      this.fill = this.querySelector('[data-price-fill]');
      this.loLbl = this.querySelector('[data-price-min-label]');
      this.hiLbl = this.querySelector('[data-price-max-label]');
      this.maxV = parseFloat(this.dataset.max) || 1;
      if (!this.lo || !this.hi) return;
      this._onLo = (e) => this.paint('lo', e.type === 'change');
      this._onHi = (e) => this.paint('hi', e.type === 'change');
      this.lo.addEventListener('input', this._onLo);
      this.lo.addEventListener('change', this._onLo);
      this.hi.addEventListener('input', this._onHi);
      this.hi.addEventListener('change', this._onHi);
      this.paint(null, false);
    }
    fmt(v) { try { return '₹' + Number(v).toLocaleString('en-IN'); } catch (e) { return '₹' + v; } }
    paint(which, commit) {
      let lo = parseFloat(this.lo.value), hi = parseFloat(this.hi.value);
      if (lo > hi) { if (which === 'lo') { lo = hi; this.lo.value = lo; } else { hi = lo; this.hi.value = hi; } }
      const pct = (v) => (v / this.maxV) * 100;
      if (this.fill) { this.fill.style.left = pct(lo) + '%'; this.fill.style.right = (100 - pct(hi)) + '%'; }
      if (this.loLbl) this.loLbl.textContent = this.fmt(lo);
      if (this.hiLbl) this.hiLbl.textContent = this.fmt(hi);
      if (commit) this.commit(lo, hi);
    }
    commit(lo, hi) {
      const u = new URL(this.dataset.base, location.origin);
      if (lo > 0) u.searchParams.set(this.dataset.gte, Math.round(lo));
      if (hi < this.maxV) u.searchParams.set(this.dataset.lte, Math.round(hi));
      this.dispatchEvent(new CustomEvent('coll:filter', { bubbles: true, detail: { url: u.pathname + (u.search || '') } }));
    }
  }
  if (!customElements.get('svastika-price-range')) customElements.define('svastika-price-range', SvastikaPriceRange);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown-element"] && !Shopify.designMode) return;
  try {
    /* <svastika-countdown> — shared by the sale band/bar and the festival band. svstk-7q2x9k3 */
  if (!customElements.get('svastika-countdown')) {
    class SvastikaCountdown extends HTMLElement {
      connectedCallback() {
        const raw = this.getAttribute('data-target') || '';
        this.target = /^\d+$/.test(raw.trim()) ? Number(raw.trim()) : new Date(raw).getTime();
        this.els = {
          d: this.querySelector('[data-cd-days]'), h: this.querySelector('[data-cd-hrs]'),
          m: this.querySelector('[data-cd-min]'), s: this.querySelector('[data-cd-sec]'),
        };
        if (isNaN(this.target)) return;
        // Reduced motion: a per-second readout is exactly the kind of continuous movement the
        // preference asks us to stop, so tick once a minute instead. A seconds box that only
        // refreshes every 60s would print a stale number, so the host is flagged and each
        // consumer's CSS drops its seconds cell (see [data-cd-coarse] there).
        const mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
        this.coarse = !!(mq && mq.matches);
        if (this.coarse) this.setAttribute('data-cd-coarse', '');
        this.tick();
        this._t = setInterval(() => this.tick(), this.coarse ? 60000 : 1000);
      }
      disconnectedCallback() { if (this._t) clearInterval(this._t); }
      pad(n) { return String(n).padStart(2, '0'); }
      tick() {
        let d = this.target - Date.now();
        if (d <= 0) {
          if (this._t) clearInterval(this._t);
          this.hidden = true; // target passed while viewing — remove the stale timer
          return;
        }
        const days = Math.floor(d / 86400000); d -= days * 86400000;
        const hrs = Math.floor(d / 3600000); d -= hrs * 3600000;
        const min = Math.floor(d / 60000); d -= min * 60000;
        const sec = Math.floor(d / 1000);
        if (this.els.d) this.els.d.textContent = String(days);
        if (this.els.h) this.els.h.textContent = this.pad(hrs);
        if (this.els.m) this.els.m.textContent = this.pad(min);
        if (this.els.s && !this.coarse) this.els.s.textContent = this.pad(sec);
      }
    }
    customElements.define('svastika-countdown', SvastikaCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-dimensions"] && !Shopify.designMode) return;
  try {
    /* <svastika-dims> — self-contained, global PDP dimensions carousel (browse-only; one slide per size).
     Mirrors the old <svastika-pdp>.initDims(): off-screen slide images parked in [data-ph-dim] and
     injected on approach (active ±1) so nothing background-fetches; swiping never changes the buy box.
     SELF-PRIMES via a ResizeObserver — the track has clientWidth 0 while its accordion (<details> on
     Gold & Silver, .is-open panel on Premium) is closed, so we position on the first non-zero width.
     Public: goToVariant(id) — one-way sync from the buy box (records target; scrolls once primed). */
  class SvastikaDims extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      const track = this.querySelector('[data-dimc]');
      if (!track) return;
      this._track = track;
      const slides = [...track.querySelectorAll('[data-dimc-slide]')];
      if (!slides.length) return;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const idxOf = new Map(); // variant id -> slide index
      slides.forEach((s, i) => { if (s.dataset.dimcSlide) idxOf.set(parseInt(s.dataset.dimcSlide, 10), i); });

      // Inject a slide's parked diagram image once (deterministic on-demand).
      const ensure = (n) => {
        const s = slides[n];
        if (!s || s.dataset.phDone) return;
        const ph = s.querySelector('[data-ph-dim]');
        if (ph) {
          const img = document.createElement('img');
          img.className = 'pdp-acc__diagram-img';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.alt = ph.dataset.phAlt || '';
          if (ph.dataset.phW) img.width = ph.dataset.phW;
          if (ph.dataset.phH) img.height = ph.dataset.phH;
          img.sizes = '(max-width: 900px) 88vw, 260px';
          if (ph.dataset.phSrcset) img.srcset = ph.dataset.phSrcset;
          img.src = ph.dataset.phSrc;
          ph.replaceWith(img);
        }
        s.dataset.phDone = '1';
      };

      let idx = 0;
      const dotsWrap = this.querySelector('[data-dimc-dots]');
      const dots = [];
      if (dotsWrap && slides.length > 1) {
        slides.forEach((s, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'pdp-dimc__dot';
          const sizeEl = s.querySelector('.pdp-dimc__size');
          const label = sizeEl && sizeEl.textContent.trim() ? sizeEl.textContent.trim() : 'Size ' + (i + 1);
          b.setAttribute('aria-label', label);
          b.addEventListener('click', () => go(i));
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      // Desktop arrow nav (swipe isn't obvious with a mouse); go() clamps, so ends are safe.
      const prevBtn = this.querySelector('[data-dimc-prev]');
      const nextBtn = this.querySelector('[data-dimc-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => go(idx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => go(idx + 1));

      const setActive = (n) => {
        idx = n;
        dots.forEach((d, i) => {
          const on = i === n;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        if (prevBtn) prevBtn.disabled = n <= 0;
        if (nextBtn) nextBtn.disabled = n >= slides.length - 1;
      };

      const jump = (n, smooth) => {
        this._navving = true;
        clearTimeout(this._navT);
        this._navT = setTimeout(() => { this._navving = false; }, 500);
        track.scrollTo({ left: n * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
        setActive(n);
      };

      const go = (i) => {
        const n = Math.max(0, Math.min(slides.length - 1, i));
        ensure(n); ensure(n + 1); ensure(n - 1);
        jump(n, true);
      };

      // Keep dots in sync when the USER swipes (programmatic moves are guarded out).
      let raf;
      track.addEventListener('scroll', () => {
        if (this._navving) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const n = Math.round(track.scrollLeft / track.clientWidth);
          if (n !== idx) { ensure(n); ensure(n + 1); ensure(n - 1); setActive(n); }
        });
      }, { passive: true });

      // One-way sync target for the buy box. Records the target so a size picked BEFORE the accordion
      // opens still lands correctly on prime; scrolls instantly (no THROUGH-scroll glitch) once primed.
      this.goToVariant = (id) => {
        const n = idxOf.get(parseInt(id, 10));
        if (n == null) return;
        this._target = n;
        if (!this._primed) return;
        ensure(n); ensure(n + 1); ensure(n - 1);
        jump(n, false);
      };

      // Prime once the carousel is actually REVEALED (accordion opened AND scrolled near view). A closed
      // <details> (content-visibility:hidden) and a display:none Premium panel both block
      // IntersectionObserver, so this fires exactly when the carousel becomes visible — no wrapper-specific
      // hook, and off-screen slide images stay un-injected until then. clientWidth is > 0 once IO reports
      // intersecting; the guard covers the paranoid edge. NOTE: don't prime on clientWidth alone — a closed
      // <details> keeps a non-zero clientWidth in Chromium, which would prime (and inject) while shut.
      const prime = () => {
        if (this._primed || track.clientWidth === 0) return;
        this._primed = true;
        let cur = this._target;
        if (cur == null) {
          const c = parseInt(this.dataset.current, 10);
          cur = idxOf.has(c) ? idxOf.get(c) : 0;
        }
        ensure(cur); ensure(cur + 1); ensure(cur - 1);
        jump(cur, false);
      };
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver((entries) => {
          for (const e of entries) {
            if (e.isIntersecting) { prime(); break; }
          }
          if (this._primed && this._io) { this._io.disconnect(); this._io = null; }
        }, { rootMargin: '200px' });
        this._io.observe(track);
      } else {
        // No IntersectionObserver — prime on first pointer/focus into the element.
        this.addEventListener('pointerenter', prime, { once: true });
        this.addEventListener('focusin', prime, { once: true });
      }

      this._initZoom(slides, go, () => idx);
    }

    /* Fullscreen zoom — ported from the gallery viewer (<svastika-pdp>.initZoom): tap/click to open,
       double-tap / click / wheel / pinch to zoom, drag to pan, swipe or arrows between sizes, swipe down
       or Esc to close. Moving between sizes here also moves the carousel underneath. svstk-7q2x9k3 */
    _initZoom(slides, go, curIdx) {
      const dlg = this.querySelector('[data-dimz-dialog]');
      if (!dlg) return;
      const items = slides.map((s, i) => {
        const b = s.querySelector('[data-dimz-open]');
        const ph = s.querySelector('[data-ph-dim]');
        return b ? { i, btn: b, src: b.dataset.dimzSrc, alt: (ph && ph.dataset.phAlt) || '' } : null;
      }).filter(Boolean);
      if (!items.length) return;
      const img = dlg.querySelector('[data-dimz-img]');
      const stageEl = dlg.querySelector('[data-dimz-stage]');
      const countEl = dlg.querySelector('[data-dimz-count]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const ZMAX = 2.5, ZCEIL = 4;
      let pos = 0, scale = 1, tx = 0, ty = 0, opener = null;
      dlg.classList.toggle('is-solo', items.length < 2);
      const rect = () => stageEl.getBoundingClientRect();
      const applyT = () => { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; };
      const resetT = () => { scale = 1; tx = 0; ty = 0; img.style.transform = 'translate(0,0) scale(1)'; dlg.classList.remove('is-zoomed'); };
      const clamp = () => {
        const r = rect();
        const mx = Math.max(0, (img.clientWidth * scale - r.width) / 2);
        const my = Math.max(0, (img.clientHeight * scale - r.height) / 2);
        tx = Math.min(mx, Math.max(-mx, tx));
        ty = Math.min(my, Math.max(-my, ty));
      };
      const setZoom = (to, px, py) => {
        if (to <= 1.01) { resetT(); return; }
        const r = rect();
        const fx = (px == null ? r.left + r.width / 2 : px) - (r.left + r.width / 2);
        const fy = (py == null ? r.top + r.height / 2 : py) - (r.top + r.height / 2);
        const k = to / scale;
        tx = fx + (tx - fx) * k;
        ty = fy + (ty - fy) * k;
        scale = to;
        dlg.classList.add('is-zoomed');
        clamp(); applyT();
      };
      const render = () => {
        const it = items[pos];
        resetT();
        dlg.classList.add('is-loading');
        img.onload = () => dlg.classList.remove('is-loading');
        img.onerror = () => dlg.classList.remove('is-loading');
        img.alt = it.alt;
        img.src = it.src;                 // 2048 fetched ONLY here; cached by URL for re-open
        if (countEl) countEl.textContent = (pos + 1) + ' / ' + items.length;
        if (it.i !== curIdx()) go(it.i);
      };
      const goTo = (p) => { pos = (p + items.length) % items.length; render(); };
      const open = (p, from) => {
        pos = p; opener = from || null;
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
        document.documentElement.classList.add('svstk-zoom-lock');
        render();
        if (reduce) dlg.classList.add('is-in');
        else { dlg.classList.remove('is-in'); void dlg.offsetWidth; dlg.classList.add('is-in'); }
        const cb = dlg.querySelector('[data-dimz-close]'); if (cb) cb.focus({ preventScroll: true });
      };
      const close = () => {
        if (dlg.dataset.closing) return;
        dlg.dataset.closing = '1';
        dlg.classList.remove('is-in');
        const done = () => { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } document.documentElement.classList.remove('svstk-zoom-lock'); resetT(); delete dlg.dataset.closing; if (opener) opener.focus({ preventScroll: true }); };
        if (reduce) done(); else setTimeout(done, 260);
      };
      items.forEach((it, p) => it.btn.addEventListener('click', () => open(p, it.btn)));
      const bind = (sel, fn) => { const el = dlg.querySelector(sel); if (el) el.addEventListener('click', fn); };
      bind('[data-dimz-close]', close);
      bind('[data-dimz-prev]', () => goTo(pos - 1));
      bind('[data-dimz-next]', () => goTo(pos + 1));
      dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
      dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') goTo(pos - 1); else if (e.key === 'ArrowRight') goTo(pos + 1); });
      const pts = new Map();
      let pan = null, pinch = null, lastTap = 0;
      const distp = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
      stageEl.addEventListener('pointerdown', (e) => {
        if (stageEl.setPointerCapture) stageEl.setPointerCapture(e.pointerId);
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2) { const a = [...pts.values()]; pinch = { d: distp(a[0], a[1]), s: scale, mx: (a[0].x + a[1].x) / 2, my: (a[0].y + a[1].y) / 2 }; pan = null; }
        else if (pts.size === 1) { pan = { x: e.clientX, y: e.clientY, tx, ty, t: Date.now(), moved: false, type: e.pointerType, target: e.target }; }
      });
      stageEl.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const a = [...pts.values()];
        if (pts.size === 2 && pinch) { const d = distp(a[0], a[1]); setZoom(Math.min(ZCEIL, Math.max(1, pinch.s * (d / pinch.d))), pinch.mx, pinch.my); }
        else if (pts.size === 1 && pan) {
          const dx = e.clientX - pan.x, dy = e.clientY - pan.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) pan.moved = true;
          if (scale > 1) { tx = pan.tx + dx; ty = pan.ty + dy; clamp(); applyT(); }
        }
      });
      const up = (e) => {
        const p = pan;
        pts.delete(e.pointerId);
        if (pts.size < 2) pinch = null;
        if (pts.size !== 0 || !p) return;
        pan = null;
        const dx = e.clientX - p.x, dy = e.clientY - p.y, quick = Date.now() - p.t < 300;
        if (!p.moved && quick) {
          if (p.target === img) {
            if (p.type === 'mouse') setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY);
            else { const now = Date.now(); if (now - lastTap < 300) { setZoom(scale > 1 ? 1 : ZMAX, e.clientX, e.clientY); lastTap = 0; } else lastTap = now; }
          } else { close(); }
        } else if (scale <= 1.01 && quick) {
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) goTo(pos + (dx < 0 ? 1 : -1));
          else if (dy > 90 && dy > Math.abs(dx)) close();
        }
      };
      stageEl.addEventListener('pointerup', up);
      stageEl.addEventListener('pointercancel', up);
      stageEl.addEventListener('wheel', (e) => { e.preventDefault(); setZoom(Math.min(ZCEIL, Math.max(1, scale * (e.deltaY < 0 ? 1.18 : 0.85))), e.clientX, e.clientY); }, { passive: false });
    }

    disconnectedCallback() {
      if (this._io) { this._io.disconnect(); this._io = null; }
    }
  }
  if (!customElements.get('svastika-dims')) customElements.define('svastika-dims', SvastikaDims);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-pin-locate"] && !Shopify.designMode) return;
  try {
    /* svastika · slowmade delivery pin — one shared contract for both PDP controllers (svstk-7q2x9k3) */
  (() => {
    if (window.svstkDeliveryPin) return;
    const KEY = 'svstk:delivery-pin';
    const GEO_URL = 'https://apps.svastika.in/api/geo';
    const IP_TTL = 7 * 864e5;
    const MISS_TTL = 864e5;
    const PIN_RE = /^[1-9]\d{5}$/;

    const read = () => {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    };
    const write = (v) => {
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode / blocked storage: run without memory */ }
    };
    /* A usable stored place: the shopper's own pin (kept until they type another), or a fresh IP guess. */
    const stored = () => {
      const v = read();
      if (!v || !PIN_RE.test(v.pin || '') || !v.district || !v.state) return null;
      if (v.src === 'user' || Date.now() - (v.ts || 0) < IP_TTL) return v;
      return null;
    };
    const recentMiss = () => {
      const v = read();
      return !!(v && v.miss && Date.now() - (v.ts || 0) < MISS_TTL);
    };
    const idle = (fn) => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 200);
    };

    let request = null; // one in-flight lookup per page, shared by every caller
    const lookup = () => {
      if (!request) {
        const opts = { credentials: 'omit' };
        if (window.AbortSignal && AbortSignal.timeout) opts.signal = AbortSignal.timeout(6000);
        request = fetch(GEO_URL, opts)
          .then((r) => (r.ok ? r.json() : null))
          .then((d) => {
            if (d && d.ok && PIN_RE.test(d.pin || '') && d.district && d.state) {
              const place = { pin: d.pin, district: d.district, state: d.state, src: 'ip', ts: Date.now() };
              if (!(stored() || {}).src) write(place); // never overwrite a pin typed meanwhile
              return place;
            }
            // Outside India: don't ask again today. An Indian IP with no city (or Cloudflare's location
            // headers switched off) is NOT remembered, so the next product page retries.
            if (d && d.country && d.country !== 'IN') write({ miss: 1, ts: Date.now() });
            return null;
          })
          .catch(() => null); // network/timeout: not remembered, the next page may retry
      }
      return request;
    };

    window.svstkDeliveryPin = {
      /* Called after a shopper-typed pincode validates. */
      remember(pin, district, state) {
        if (PIN_RE.test(pin)) write({ pin, district, state, src: 'user', ts: Date.now() });
      },
      /* cb(place) at most once with { pin, district, state, src } — synchronously from storage when we
         already know the shopper's place; else after the checker nears the viewport and the browser idles. */
      whenReady(wrap, cb) {
        const known = stored();
        if (known) { cb(known); return; }
        if (recentMiss()) return;
        const go = () => idle(() => lookup().then((p) => { if (p) cb(p); }));
        if (!('IntersectionObserver' in window)) { go(); return; }
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); go(); }
        }, { rootMargin: '200px 0px' });
        io.observe(wrap);
      },
    };
    /* Section and snippet JS ship as separate Shopify bundles with no guaranteed order — a
       controller that connected first waits for this event (see `onDeliveryPin` in both PDPs). */
    document.dispatchEvent(new CustomEvent('svstk:delivery-pin'));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-rail"] && !Shopify.designMode) return;
  try {
    // <svastika-rail> — arrow control for a one-row card rail (size picker, family swatch).
  if (!customElements.get('svastika-rail')) {
    class SvstkRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-svstk-cardrail]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-rail-prev]');
        this.nextBtn = this.querySelector('[data-rail-next]');
        this._sync = this._sync.bind(this);
        this.track.addEventListener('scroll', this._sync, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._go(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._go(1));
        // Off-screen or inside a content-visibility:auto ancestor the track measures 0 wide, so the
        // connect-time read would wrongly report "no overflow" — re-measure whenever it resizes.
        if ('ResizeObserver' in window) {
          this._ro = new ResizeObserver(this._sync);
          this._ro.observe(this.track);
        }
        this.addEventListener('contentvisibilityautostatechange', this._sync);
        this._sync();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this._sync);
        if (this._ro) this._ro.disconnect();
        clearTimeout(this._settle);
      }

      _step() {
        const first = this.track.firstElementChild;
        const cardW = first ? first.getBoundingClientRect().width : this.track.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 10;
        return Math.round(cardW + gap);
      }

      _go(dir) {
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * this._step(), behavior: still ? 'auto' : 'smooth' });
        // Don't leave the end-state disabling to the scroll event alone: a smooth scroll can settle
        // without a final scroll event, and some contexts throttle them entirely.
        clearTimeout(this._settle);
        this._settle = setTimeout(this._sync, still ? 0 : 400);
      }

      _sync() {
        const t = this.track;
        if (!t) return;
        const max = t.scrollWidth - t.clientWidth;
        const overflows = t.clientWidth > 0 && max > 2;
        this.classList.toggle('is-railed', overflows);
        if (this.prevBtn) this.prevBtn.disabled = !overflows || t.scrollLeft <= 1;
        if (this.nextBtn) this.nextBtn.disabled = !overflows || t.scrollLeft >= max - 1;
      }
    }
    customElements.define('svastika-rail', SvstkRail);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* svstk-7q2x9k3 · product-card quick-add. The card is not inside a <svastika-collection>, so nothing
     else handles its button: a multi-variant product opens the quick-add modal (quickadd:open), a
     single-variant one goes straight to the cart drawer (cart:add, optimistic display payload) — the
     same contract collection-engine uses. A container that already handled the click (it called
     preventDefault) wins, so the add never fires twice. */
  (function () {
    if (window.__svstkPcardQa) return;
    window.__svstkPcardQa = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pcard-qa]') : null;
      if (!b || e.defaultPrevented || b.disabled) return;
      e.preventDefault();
      if (b.dataset.quickAdd) {
        document.dispatchEvent(new CustomEvent('quickadd:open', { bubbles: true, detail: { url: b.dataset.quickAdd } }));
        return;
      }
      var id = parseInt(b.dataset.variantId, 10);
      if (!id) return;
      var price = parseInt(b.dataset.price, 10) || 0;
      var item = { id: id, quantity: 1, price: price,
        display: { title: b.dataset.title || '', variant: b.dataset.variantTitle || '', image: b.dataset.image || '', price: price, mrp: parseInt(b.dataset.compare, 10) || 0, vol: '', product_id: b.dataset.productId || '' } };
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-engine"] && !Shopify.designMode) return;
  try {
    class SvastikaQuickAdd extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.body = this.querySelector('[data-qa-body]');
    if (!this.dialog || !this.body) return;
    this._onOpen = (e) => this.open(e.detail && e.detail.url);
    document.addEventListener('quickadd:open', this._onOpen);
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-qa-close]')) { e.preventDefault(); this.close(); return; }
      const add = e.target.closest('[data-qa-add]');
      if (add) { e.preventDefault(); this.add(add); }
    });
    this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
    this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
    this.dialog.addEventListener('change', (e) => { const r = e.target.closest('input[name="qa-variant"]'); if (r) this.select(r.value); });
    this.dialog.addEventListener('close', () => { document.body.style.overflow = ''; });
  }
  disconnectedCallback() { document.removeEventListener('quickadd:open', this._onOpen); if (this._ctrl) this._ctrl.abort(); }

  get SKELETON() {
    return '<div class="qa qa--skel" aria-hidden="true">'
      + '<div class="qa__media"><div class="qa-skel qa-skel--img"></div></div>'
      + '<div class="qa__info"><div class="qa-skel qa-skel--line" style="width:72%"></div>'
      + '<div class="qa-skel qa-skel--line qa-skel--sm" style="width:38%"></div>'
      + '<div class="qa-skel qa-skel--chips"><i></i><i></i><i></i></div>'
      + '<div class="qa-skel qa-skel--btn"></div></div></div>';
  }

  async open(url) {
    if (!url) return;
    // Only ever open a same-origin product URL — never fetch or navigate to an arbitrary URL a
    // forged quickadd:open event could supply.
    let u;
    try { u = new URL(url, location.origin); } catch (e) { return; }
    if (u.origin !== location.origin || !/^\/products\//.test(u.pathname)) return;
    this.body.innerHTML = this.SKELETON;
    if (!this.dialog.open && this.dialog.showModal) this.dialog.showModal();
    document.body.style.overflow = 'hidden';
    if (this._ctrl) this._ctrl.abort();
    this._ctrl = new AbortController();
    try {
      u.searchParams.set('section_id', 'quick-add');
      const res = await fetch(u.toString(), { signal: this._ctrl.signal });
      if (!res.ok) throw new Error('fetch failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const content = doc.querySelector('[data-qa-content]');
      if (!content) throw new Error('no content');
      this.body.replaceChildren(content);
      this.hydrate();
    } catch (err) {
      if (err.name === 'AbortError') return;
      location.assign(url); // graceful fallback to the full product page
    }
  }

  hydrate() {
    const checked = this.body.querySelector('input[name="qa-variant"]:checked')
      || this.body.querySelector('input[name="qa-variant"]:not([disabled])')
      || this.body.querySelector('input[name="qa-variant"]');
    if (checked) { checked.checked = true; this.select(checked.value); }
    const focusTarget = checked || this.body.querySelector('[data-qa-add]');
    if (focusTarget && focusTarget.focus) { try { focusTarget.focus({ preventScroll: true }); } catch (e) {} }
  }

  select(id) {
    if (!id) return;
    const esc = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    const radio = this.body.querySelector('input[name="qa-variant"][value="' + esc + '"]');
    const img = this.body.querySelector('.qa__img');
    if (radio && img && radio.dataset.img) { img.setAttribute('src', radio.dataset.img); img.removeAttribute('srcset'); }
    this.body.querySelectorAll('[data-qa-price-for]').forEach((el) => { el.hidden = el.getAttribute('data-qa-price-for') !== String(id); });
    this.body.querySelectorAll('[data-qa-dims-for]').forEach((el) => { el.hidden = el.getAttribute('data-qa-dims-for') !== String(id); });
    const add = this.body.querySelector('[data-qa-add]');
    if (add) { add.dataset.id = id; add.disabled = radio ? radio.disabled : false; }
  }

  add(btn) {
    const id = btn.dataset.id;
    if (!id || btn.disabled) return;
    // Display data from the selected variant's radio → the drawer paints the line INSTANTLY (optimistic path,
    // no section render) instead of a skeleton + full round-trip. Mirrors the PDP add's cart:add contract.
    const esc = (window.CSS && CSS.escape) ? CSS.escape(id) : id;
    const radio = this.body && this.body.querySelector('input[name="qa-variant"][value="' + esc + '"]');
    const item = { id: Number(id), quantity: 1 };
    if (radio && btn.dataset.title) {
      const vt = radio.dataset.vtitle || '';
      item.price = parseInt(radio.dataset.price, 10) || 0;
      item.display = { title: btn.dataset.title, variant: vt === 'Default Title' ? '' : vt, image: radio.dataset.thumb || '', price: item.price, mrp: parseInt(btn.dataset.compare, 10) || 0, vol: '', product_id: btn.dataset.productId || '' };
    }
    this.close();
    document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [item] } }));
  }

  close() {
    if (this._ctrl) this._ctrl.abort();
    if (this.dialog.open && this.dialog.close) this.dialog.close();
    document.body.style.overflow = '';
  }
}
if (!customElements.get('svastika-quick-add')) customElements.define('svastika-quick-add', SvastikaQuickAdd);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reel-player"] && !Shopify.designMode) return;
  try {
    class SvastikaReelPlayer extends HTMLElement {
    connectedCallback() {
      // Idempotent: portaling to <body> in open() re-triggers connectedCallback (moving a
      // custom element fires disconnected→connected). Without this guard every listener would
      // be bound twice — clicks fire onClick twice, cancelling toggles (the product bar/mute
      // appeared dead). Listeners persist across the move, so wiring once is correct.
      if (this._wired) return;
      this._wired = true;
      this.current = -1;
      this.savedScrollY = 0;
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wheelLock = false;
      this.portaled = false;
      this.muted = true;
      this.productCache = new Map();  // handle -> /products/<handle>.js JSON (or null)
      this.trackEl = this.querySelector('[data-rp-track]');
      // The reels payload is NOT parsed here. It is tens of KB of JSON on the homepage and on
      // every product page, and nothing before the first open needs it — parsing it at connect
      // spent that main-thread time on every page load for the majority of visitors who never
      // tap a reel. ensureData() runs it on the first open (modal: a few ms before the overlay
      // animates in is invisible).
      this._parsed = false;
      this.reels = [];
      this.popular = [];
      this.byId = {};
      this.feedList = [];
      this.activeSince = 0;
      this.activeReel = null;
      this.currentProduct = this.getAttribute('data-current-product') || '';
      this.brandHandle = this.getAttribute('data-handle') || 'svastika.in';
      this.igProfile = this.getAttribute('data-ig-profile') || '';
      this.brandLogo = this.getAttribute('data-logo') || '';

      this.querySelector('[data-rp-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-rp-mute]').addEventListener('click', () => this.toggleMute());
      this.querySelector('[data-rp-share]').addEventListener('click', () => this.share());
      this.igBtn = this.querySelector('[data-rp-ig]');
      if (this.igBtn) this.igBtn.addEventListener('click', () => this.openInsta());
      // Video-quality menu: read the persisted preference ("auto" | "<height>") and wire the control.
      this.quality = 'auto';
      try { const q = localStorage.getItem('svstk_reel_quality'); if (q) this.quality = q; } catch (e) {}
      this.qWrap = this.querySelector('[data-rp-quality-wrap]');
      this.qBtn = this.querySelector('[data-rp-quality]');
      this.qMenu = this.querySelector('[data-rp-qmenu]');
      this.qLabel = this.querySelector('[data-rp-qlabel]');
      if (this.qBtn) this.qBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleQualityMenu(); });
      if (this.qMenu) this.qMenu.addEventListener('click', (e) => { const it = e.target.closest('[data-q]'); if (it) this.pickQuality(it.getAttribute('data-q')); });
      // Auto mode re-evaluates when the connection changes (Network Info API; absent on iOS Safari → stays best).
      if (navigator.connection && navigator.connection.addEventListener) {
        navigator.connection.addEventListener('change', () => { if (!this.hidden && this.quality === 'auto') this.applyQualityToActive(); });
      }
      this.updateQLabel();
      this.trackEl.addEventListener('click', (e) => this.onClick(e));
      this.trackEl.addEventListener('pointerdown', (e) => this.onScrubStart(e));
      this.trackEl.addEventListener('wheel', (e) => {
        if (this.hidden) return;
        if (window.matchMedia && !window.matchMedia('(pointer: fine)').matches) return; // touch/coarse: native snap
        // Let a scrollable product panel consume the wheel until it hits a scroll boundary
        // (only then does the wheel fall through to reel navigation).
        const panel = e.target.closest ? e.target.closest('.rpf-rail') : null;
        if (panel && panel.scrollHeight > panel.clientHeight + 1) {
          const atTop = panel.scrollTop <= 0;
          const atEnd = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 1;
          if (!((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atEnd))) return;
        }
        e.preventDefault(); // own reel navigation on fine pointers — no native free-scroll leak between advances
        // ONE advance per gesture. Every wheel tick resets an idle timer, so the lock only clears
        // after the wheel goes quiet (~150ms). A trackpad/high-res momentum tail keeps resetting it
        // and is swallowed — a single flick can't roll through several reels; a fresh flick after a
        // pause advances one more. The deltaY guard backstops a tapering tail that outlives the gap.
        clearTimeout(this._wheelIdleT);
        this._wheelIdleT = setTimeout(() => { this.wheelLock = false; }, 150);
        if (this.wheelLock) return;
        if (Math.abs(e.deltaY) < 6) return; // ignore jitter / mostly-horizontal wheel for the advance
        this.wheelLock = true;
        // Advance from the in-flight target (not this.current, which the IntersectionObserver
        // mutates mid-animation) so a quick second scroll can't compute the wrong direction.
        const base = (this._targetIdx != null) ? this._targetIdx : this.current;
        this.scrollToIndex(base + (e.deltaY > 0 ? 1 : -1));
      }, { passive: false });

      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-rp-open]');
        if (!t) return;
        e.preventDefault();
        let feed = null;
        // The scoped feed id-array is emitted ONCE per row (on the track / stories row), not on
        // every card. closest() also matches the trigger itself, so markup that still carries it
        // per-card keeps working.
        const holder = t.closest('[data-rp-feed]');
        const raw = holder ? holder.getAttribute('data-rp-feed') : null;
        if (raw) { try { feed = JSON.parse(raw); } catch (err) { feed = null; } }
        this.lastTrigger = t;
        this.open(t.getAttribute('data-rp-open'), feed);
      });
      document.addEventListener('click', (e) => {
        if (this.hidden || !this.qMenu || this.qMenu.hidden) return;
        if (!e.target.closest('[data-rp-quality-wrap]')) this.closeQualityMenu();
      });
      document.addEventListener('keydown', (e) => {
        if (this.hidden) return;
        if (e.key === 'Escape') { if (this.qMenu && !this.qMenu.hidden) { this.closeQualityMenu(); if (this.qBtn) this.qBtn.focus(); } else this.close(); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); this.scrollToIndex(this.current + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); this.scrollToIndex(this.current - 1); }
        else if (e.key === 'Tab') {
          const f = this.querySelectorAll('button, a[href], select, [tabindex]:not([tabindex="-1"])');
          const list = Array.from(f).filter((el) => el.offsetParent !== null);
          if (!list.length) return;
          const first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      window.addEventListener('pagehide', () => this.flushView());
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') this.flushView(); });
      // Keep the feed height stable while scrolling: re-measure ONLY on a real viewport
      // change (rotation / a WIDTH change), never on the height-only 'resize' the mobile
      // URL bar fires as you scroll — reacting to that is what yanked the snap back a reel.
      this._vw = window.innerWidth;
      window.addEventListener('resize', () => {
        if (this.hidden) return;
        if (window.innerWidth === this._vw) return; // height-only (URL bar) → ignore
        this._vw = window.innerWidth;
        this.setHeight();
      });
      window.addEventListener('orientationchange', () => { if (this.hidden) return; setTimeout(() => this.setHeight(), 250); });
    }

    // Parse #svastika-reels-data on demand (first open), exactly once. Every consumer of
    // this.reels / this.byId / this.popular runs after open(), so this is the only hook needed.
    ensureData() {
      if (this._parsed) return;
      this._parsed = true;
      const data = document.getElementById('svastika-reels-data');
      if (data) {
        try {
          const parsed = JSON.parse(data.textContent);
          this.reels = parsed.reels || [];
          this.popular = parsed.popular || [];
        } catch (e) { this.reels = []; this.popular = []; }
      }
      this.byId = {};
      this.reels.forEach((r) => { this.byId[r.id] = r; });
      if (!this.feedList.length) this.feedList = this.reels;
    }
    // `popular` is now the ordered id ARRAY for the one window this player asks for; the section
    // picks it with data-popular-window. Older payloads inlined the whole {window: ids} map, and a
    // cached page can still serve one — read both shapes rather than silently losing the end-cap.
    popularIds() {
      const p = this.popular;
      if (Array.isArray(p)) return p;
      const win = this.getAttribute('data-popular-window') || '30';
      return (p && p[win]) || [];
    }

    // Pin the feed to a fixed pixel height so slides don't resize mid-scroll (see the resize note above).
    setHeight() { const h = window.innerHeight; if (h) this.style.setProperty('--rpf-h', h + 'px'); }

    money(cents) {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) return Shopify.formatMoney(cents, theme.moneyFormat);
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    }
    esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
    /* Allow only http(s)/relative URLs into href/window.open — blocks a javascript: permalink from a bad reels-index. */
    sUrl(u) { u = String(u == null ? '' : u); return (/^https?:\/\//i.test(u) || u.charAt(0) === '/') ? u : '#'; }

    build() {
      if (this.io) this.io.disconnect();
      const reels = this.feedList;
      this.trackEl.innerHTML = reels.map((r, i) => this.slideHTML(r, i)).join('') + this.endcapHTML(reels.length);
      this.slides = Array.from(this.trackEl.querySelectorAll('.rpf-slide'));
      this.io = new IntersectionObserver((entries) => {
        let best = null;
        for (const en of entries) if (en.isIntersecting && (!best || en.intersectionRatio > best.intersectionRatio)) best = en;
        if (best) { const idx = parseInt(best.target.getAttribute('data-i'), 10); if (idx !== this.current) this.setActive(idx); }
      }, { root: this.trackEl, threshold: [0.5, 0.75] });
      this.slides.forEach((s) => this.io.observe(s));
    }

    qtyHTML() {
      return '<div class="rpf-qty"><button type="button" data-rp-qdec aria-label="Decrease">−</button><span data-rp-qval>1</span><button type="button" data-rp-qinc aria-label="Increase">+</button></div>';
    }
    productHTML(p, pi) {
      const price = '<span>' + this.money(p.price) + '</span>' + (p.compare_price > p.price ? '<del>' + this.money(p.compare_price) + '</del>' : '');
      const url = p.handle ? '/products/' + encodeURIComponent(p.handle) : '#';
      return '<div class="rpf-prod' + (pi === 0 ? ' rpf-prod--primary' : '') + '" data-handle="' + this.esc(p.handle) + '" data-product="' + Number(p.product_id || 0) + '">' +
        // 2026-09-30: the thumbnail lands on the product too (it was dead). A duplicate of the title link,
        // so it stays out of the tab order and the a11y tree. The card is NOT stretched: its option pills,
        // qty stepper and Add button sit close together and a missed tap must not navigate away. svstk-reach
        (p.handle ? '<a class="rpf-prod__imglink" href="' + this.esc(url) + '" tabindex="-1" aria-hidden="true" data-svstk-reach="reel-prod">' : '') +
        (p.image ? '<img class="rpf-prod__img" src="' + this.esc(p.image) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '<span class="rpf-prod__img"></span>') +
        (p.handle ? '</a>' : '') +
        '<div class="rpf-prod__main">' +
          '<a class="rpf-prod__title" href="' + this.esc(url) + '">' + this.esc(p.title) + '</a>' +
          '<p class="rpf-prod__price" data-rp-price>' + price + '</p>' +
          '<div class="rpf-prod__opts" data-rp-opts hidden></div>' +
          '<div class="rpf-prod__buy">' + this.qtyHTML() +
            (p.variant_id ? '<button type="button" class="rpf-add" data-rp-add data-variant="' + Number(p.variant_id) + '">Add to cart</button>' : '') +
          '</div>' +
          (p.handle ? '<a class="rpf-prod__more" href="' + this.esc(url) + '">View full details &#8599;</a>' : '') +
        '</div>' +
      '</div>';
    }
    barHTML(prods) {
      // Multiple products → an overlapped image stack + count, opening the full list. Single → the buy bar.
      if (prods.length > 1) {
        const imgs = prods.slice(0, 3).map((p, i) =>
          (p.image ? '<img class="rpf-bar__stackimg" src="' + this.esc(p.image) + '" alt="" width="46" height="46" loading="lazy" decoding="async" style="z-index:' + (3 - i) + '">' : '<span class="rpf-bar__stackimg" style="z-index:' + (3 - i) + '"></span>')
        ).join('');
        return '<button type="button" class="rpf-bar rpf-bar--multi" data-rp-sheet-toggle aria-expanded="false" data-svstk-buy>' +
          '<span class="rpf-bar__stack">' + imgs + '</span>' +
          '<span class="rpf-bar__info"><span class="rpf-bar__title">' + prods.length + ' products in this reel</span></span>' +
          '<span class="rpf-bar__cta">Shop</span>' +
        '</button>';
      }
      const p = prods[0];
      const price = '<span>' + this.money(p.price) + '</span>' + (p.compare_price > p.price ? '<del>' + this.money(p.compare_price) + '</del>' : '');
      return '<button type="button" class="rpf-bar" data-rp-sheet-toggle aria-expanded="false" data-svstk-buy>' +
        (p.image ? '<img class="rpf-bar__img" src="' + this.esc(p.image) + '" alt="" width="44" height="44" loading="lazy" decoding="async">' : '<span class="rpf-bar__img"></span>') +
        '<span class="rpf-bar__info"><span class="rpf-bar__title">' + this.esc(p.title) + '</span><span class="rpf-bar__price">' + price + '</span></span>' +
        '<span class="rpf-bar__cta">Shop Now</span>' +
      '</button>';
    }
    slideHTML(r, i) {
      let prods = (r.products || []).slice();
      if (this.currentProduct) {
        const cp = String(this.currentProduct);
        prods.sort((a, b) => (String(b.product_id) === cp ? 1 : 0) - (String(a.product_id) === cp ? 1 : 0));
      }
      const products = prods.map((p, pi) => this.productHTML(p, pi)).join('');
      return '<section class="rpf-slide' + (prods.length ? '' : ' rpf-slide--noprods') + '" data-i="' + i + '">' +
        '<div class="rpf-slide__media">' +
          (r.poster ? '<img class="rpf-slide__poster" src="' + this.esc(r.poster) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<video class="rpf-slide__video" playsinline muted loop preload="none" poster="' + this.esc(r.poster || '') + '"></video>' +
          '<div class="rpf-slide__cap' + (prods.length ? ' rpf-slide__cap--hasprods' : '') + '"><span class="rpf-slide__cat">' + this.esc(r.category || '') + '</span>' + (r.title ? '<h3>' + this.esc(r.title) + '</h3><button type="button" class="rpf-slide__more" data-rp-cap-more aria-expanded="false">more</button>' : '') + '</div>' +
          '<div class="rpf-slide__brand" data-sv-heirloom>' +
            (this.brandLogo ? '<img class="rpf-brand__ava" src="' + this.esc(this.brandLogo) + '" alt="" width="32" height="32" loading="lazy" decoding="async">' : '<span class="rpf-brand__ava rpf-brand__ava--mark" aria-hidden="true"></span>') +
            (function (self, r2) {
              const target = r2.permalink || self.igProfile;
              const label = self.esc(self.brandHandle);
              return target
                ? '<a class="rpf-brand__handle" href="' + self.esc(self.sUrl(target)) + '" target="_blank" rel="noopener" aria-label="' + label + ' on Instagram">' + label + '</a>'
                : '<span class="rpf-brand__handle">' + label + '</span>';
            })(this, r) +
          '</div>' +
          '<div class="rpf-scrub" data-rp-scrub><div class="rpf-scrub__track"><div class="rpf-scrub__fill"></div><div class="rpf-scrub__knob"></div></div></div>' +
        '</div>' +
        '<aside class="rpf-rail" data-rp-rail data-svstk-rail>' +
          (prods.length ? this.barHTML(prods) : '') +
          '<button type="button" class="rpf-rail__handle" data-rp-sheet-toggle aria-label="Show products"></button>' +
          '<p class="rpf-rail__head">In this video</p>' +
          '<div class="rpf-rail__list">' + products + '</div>' +
        '</aside>' +
      '</section>';
    }
    endcapHTML(n) {
      // Only offer "Show popular" when there are popular reels NOT already in this feed — otherwise the button is a dead tap.
      const ids = this.popularIds();
      const inFeed = {};
      this.feedList.forEach((r) => { if (r) inFeed[r.id] = true; });
      const hasNewPopular = ids.some((id) => this.byId[id] && !inFeed[id]);
      return '<section class="rpf-slide rpf-endcap" data-i="' + n + '"><div class="rpf-endcap__in"><p>You’re all caught up</p><div class="rpf-endcap__btns"><button type="button" class="rpf-endcap__top" data-rp-top>Back to top</button>' +
        (hasNewPopular ? '<button type="button" class="rpf-endcap__more" data-rp-popular>Show popular videos</button>' : '') +
        '</div></div></section>';
    }

    open(reelId, feedGids) {
      this.ensureData(); // first open pays the JSON.parse, not every page load
      const list = (feedGids && feedGids.length) ? feedGids.map((id) => this.byId[id]).filter(Boolean) : this.reels;
      if (!list.length) return;
      this.feedList = list;
      this.current = -1; // fresh open always (re)activates the target slide
      this.build();
      if (!this.portaled && this.parentNode !== document.body) { document.body.appendChild(this); this.portaled = true; }
      this.savedScrollY = window.scrollY || window.pageYOffset || 0;
      this.setHeight(); // fix the height before the initial scrollIntoView so snap points are stable
      this.hidden = false; this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
      document.body.style.overflow = 'hidden';
      this.lockChrome();
      let idx = this.feedList.findIndex((r) => r.id === reelId);
      if (idx < 0) idx = 0;
      requestAnimationFrame(() => { this.slides[idx].scrollIntoView({ behavior: 'auto' }); this.setActive(idx); const x = this.querySelector('[data-rp-close]'); if (x) x.focus(); });
    }
    close() {
      this.flushView();
      clearTimeout(this._snapT); this.trackEl.style.scrollSnapType = ''; this._targetIdx = null; // never leave snap disabled
      cancelAnimationFrame(this._raf); this.classList.remove('rpf--paused'); // stop the progress loop + clear pause overlay
      this.hidden = true; this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.documentElement.style.overscrollBehavior = '';
      document.body.style.overflow = '';
      this.unlockChrome();
      if (this.savedScrollY) window.scrollTo(0, this.savedScrollY);
      if (this.slides) this.slides.forEach((s) => { const v = s.querySelector('.rpf-slide__video'); if (v) v.pause(); });
      if (this.lastTrigger && this.lastTrigger.focus) { this.lastTrigger.focus(); this.lastTrigger = null; }
    }
    // The reel locks page scroll, so iOS Safari never collapses its bottom toolbar — it stays shown for the
    // whole session. With the site's light theme-color + ivory <body>, that toolbar (plus the viewport-fit
    // safe-area / overscroll region) renders LIGHT against the black reel → a light band at the bottom on
    // every reel. Paint all of it black while open (chrome tint + body/html bg), restore verbatim on close.
    lockChrome() {
      let metas = Array.from(document.querySelectorAll('meta[name="theme-color"]'));
      if (!metas.length) { const m = document.createElement('meta'); m.setAttribute('name', 'theme-color'); m.setAttribute('data-rpf-temp', ''); document.head.appendChild(m); metas = [m]; }
      this._chromeSaved = {
        metas: metas.map((m) => ({ m: m, prev: m.getAttribute('content'), temp: m.hasAttribute('data-rpf-temp') })),
        htmlBg: document.documentElement.style.backgroundColor,
        bodyBg: document.body.style.backgroundColor
      };
      metas.forEach((m) => m.setAttribute('content', '#000000'));
      document.documentElement.style.backgroundColor = '#000';
      document.body.style.backgroundColor = '#000';
    }
    unlockChrome() {
      const s = this._chromeSaved;
      if (!s) return;
      s.metas.forEach((o) => { if (o.temp) { o.m.remove(); } else if (o.prev != null) { o.m.setAttribute('content', o.prev); } });
      document.documentElement.style.backgroundColor = s.htmlBg;
      document.body.style.backgroundColor = s.bodyBg;
      this._chromeSaved = null;
    }
    scrollToIndex(i) {
      if (!this.slides) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this._targetIdx = i;
      // Turn snap OFF for the duration of the programmatic smooth scroll: mandatory snap otherwise
      // fights the animation and yanks it back a slide (the desktop "pullback"). Restore on settle.
      this.trackEl.style.scrollSnapType = 'none';
      clearTimeout(this._snapT);
      this.slides[i].scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth' });
      this._snapT = setTimeout(() => { this.trackEl.style.scrollSnapType = ''; this._targetIdx = null; }, this.reduceMotion ? 80 : 600);
    }

    setActive(idx) {
      if (idx === this.current) return; // ignore redundant re-activation (observer + rAF race)
      this.flushView();
      // Collapse any open product sheet when moving to another reel, and re-show the action rail.
      this.querySelectorAll('.rpf-rail.is-expanded').forEach((r) => { r.classList.remove('is-expanded'); const b = r.querySelector('.rpf-bar'); if (b) b.setAttribute('aria-expanded', 'false'); });
      this.classList.remove('rpf--sheet-open');
      // End-cap has no video/products → flag it so the floating action rail hides there.
      const activeSlide = this.slides[idx];
      this.classList.toggle('rpf--endcap', !!(activeSlide && activeSlide.classList.contains('rpf-endcap')));
      // No products on the active reel → the desktop product panel is gone and the video centers
      // (wider), so the floating action rail must sit inside the CENTERED video's right edge rather
      // than the with-panel offset (else it drifts to the middle of the video). See the CSS override.
      this.classList.toggle('rpf--noprods', !!(activeSlide && activeSlide.classList.contains('rpf-slide--noprods')));
      if (activeSlide) { this.hydrateSlide(activeSlide); this.syncCaption(activeSlide); this.positionCaption(activeSlide); }
      const reels = this.feedList;
      this.current = idx;
      this.slides.forEach((s, i) => {
        const v = s.querySelector('.rpf-slide__video');
        if (!v) { return; } // end-cap has no video
        const near = Math.abs(i - idx) <= 1;
        const src = this.srcFor(reels[i]); // quality-aware url (was reels[i].video)
        if (near && src) { if (v.getAttribute('src') !== src) { v.setAttribute('src', src); try { v.load(); } catch (e) {} } }
        else if (v.getAttribute('src')) { v.pause(); v.removeAttribute('src'); try { v.load(); } catch (e) {} }
        if (i === idx) { v.muted = this.muted; s.classList.add('is-active'); const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
        else { v.pause(); s.classList.remove('is-active'); }
      });
      this.classList.remove('rpf--paused'); // a freshly-activated reel autoplays
      this.tickProgress();                   // drive its scrubber
      this.activeReel = reels[idx] || null;
      if (this.igBtn) this.igBtn.hidden = !(this.activeReel && (this.activeReel.permalink || this.igProfile));
      this.syncQualityUI(this.activeReel);
      this.activeSince = performance.now();
    }

    // Track which reel ids already counted a view this session, so re-watching the
    // same reel doesn't inflate the count. ATC beacons are NOT gated (they fire every
    // time). sessionStorage so a fresh visit counts again; guarded so private-mode /
    // storage-disabled browsers degrade gracefully (treated as "not yet seen").
    viewedThisSession() {
      try { return new Set(JSON.parse(sessionStorage.getItem('svstk_reel_views') || '[]')); }
      catch (e) { return new Set(); }
    }
    markViewed(set, id) {
      set.add(id);
      try { sessionStorage.setItem('svstk_reel_views', JSON.stringify([...set])); } catch (e) {}
    }

    flushView() {
      if (!this.activeReel) return;
      const reel = this.activeReel;
      // Clear active state up-front so an early return can't double-count on a later flush.
      this.activeReel = null;
      const since = this.activeSince;
      this.activeSince = 0;
      const seen = this.viewedThisSession();
      if (seen.has(reel.id)) return; // already counted this reel this session — skip the beacon
      this.markViewed(seen, reel.id);
      const watchMs = since ? Math.round(performance.now() - since) : 0;
      const slide = this.slides && this.slides[this.current];
      const v = slide && slide.querySelector('.rpf-slide__video');
      const durationMs = Math.round((v && v.duration ? v.duration : 0) * 1000);
      const completed = v && v.duration ? (v.currentTime / v.duration) >= 0.95 : false;
      this.track('view', reel, { watch_ms: Math.min(watchMs, 3600000), duration_ms: durationMs, completed: completed });
    }
    toggleMute() {
      this.muted = !this.muted;
      this.classList.toggle('is-muted', this.muted);
      const mb = this.querySelector('[data-rp-mute]'); if (mb) mb.setAttribute('aria-pressed', this.muted ? 'true' : 'false');
      if (this.slides && this.slides[this.current]) { const v = this.slides[this.current].querySelector('.rpf-slide__video'); if (v) v.muted = this.muted; }
    }
    share() {
      const reel = this.feedList && this.feedList[this.current];
      const url = this.sUrl((reel && reel.permalink) || window.location.href);
      const title = (reel && reel.title) || document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(() => {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => this.toast('Link copied')).catch(() => window.open(url, '_blank', 'noopener'));
        return;
      }
      window.open(url, '_blank', 'noopener');
    }
    // ---- Video quality ----
    // Best (tallest) rendition for a reel. The index's `video` is byte-identical to
    // video_sources[0].url for every reel that has renditions, so the section omits the duplicate
    // and we derive it from the list; `video` is still emitted (and wins here) whenever it differs
    // or the reel has no rendition list at all.
    bestSrc(reel) {
      if (!reel) return undefined;
      if (reel.video) return reel.video;
      const s = reel.video_sources;
      return (Array.isArray(s) && s.length && s[0] && s[0].url) ? s[0].url : undefined;
    }
    // The url to load for a reel at the current quality. Null-safe: reels without video_sources
    // just play the best url (and show no gear). HLS is not inlined — a future true-ABR upgrade
    // (Approach A) would have to add it back to the payload.
    srcFor(reel) {
      const best = this.bestSrc(reel);
      if (!best) return undefined;                            // end-cap / no video
      const src = Array.isArray(reel.video_sources) ? reel.video_sources : null;
      if (!src || !src.length) return best;                   // single rendition / external url
      if (this.quality !== 'auto') {
        const h = Number(this.quality);
        const m = src.find((s) => Number(s.h) === h);
        return (m && m.url) || best;                          // chosen height missing → best
      }
      return this.autoSrc(reel, src, best);
    }
    // Auto: heuristic from the Network Information API. Slow link → smallest rendition; else best.
    autoSrc(reel, src, best) {
      const c = navigator.connection;
      const slow = !!(c && (c.saveData || /2g/.test(c.effectiveType || '') || (typeof c.downlink === 'number' && c.downlink < 1.5)));
      if (slow && src && src.length) return src[src.length - 1].url; // best-first array → last = smallest
      return best !== undefined ? best : this.bestSrc(reel);         // fast / unknown → best (iOS has no API)
    }
    // Show the gear + rebuild its menu for the active reel (renditions differ per reel). Hide when there's
    // no real choice: absent/empty video_sources OR a single rendition (a 480p-only master isn't a choice).
    syncQualityUI(reel) {
      if (!this.qWrap) return;
      const has = !!(reel && Array.isArray(reel.video_sources) && reel.video_sources.length > 1);
      this.qWrap.hidden = !has;
      this.closeQualityMenu();
      if (has) { this.buildQualityMenu(reel); this.updateQLabel(); }
    }
    buildQualityMenu(reel) {
      if (!this.qMenu || !reel || !Array.isArray(reel.video_sources)) return;
      const src = reel.video_sources;                 // best (tallest) first
      const heights = src.map((s) => String(s.h));
      // What's actually effective on THIS reel (a stored height the reel lacks → falls back to Auto/best).
      const effective = (this.quality === 'auto' || heights.indexOf(this.quality) < 0) ? 'auto' : this.quality;
      const opts = [{ v: 'auto', label: 'Auto' }].concat(src.map((s) => ({ v: String(s.h), label: s.h + 'p' })));
      this.qMenu.innerHTML = opts.map((o) =>
        '<button type="button" class="rpf__qitem" role="menuitemradio" data-q="' + this.esc(o.v) + '" aria-checked="' + (o.v === effective ? 'true' : 'false') + '">' + this.esc(o.label) + '</button>'
      ).join('');
    }
    updateQLabel() { if (this.qLabel) this.qLabel.textContent = this.quality === 'auto' ? 'Auto' : (this.quality + 'p'); }
    toggleQualityMenu() { if (this.qMenu && this.qMenu.hidden) this.openQualityMenu(); else this.closeQualityMenu(); }
    openQualityMenu() {
      if (!this.qMenu || this.qWrap.hidden) return;
      this.qMenu.hidden = false;
      if (this.qBtn) this.qBtn.setAttribute('aria-expanded', 'true');
      const first = this.qMenu.querySelector('[aria-checked="true"]') || this.qMenu.querySelector('.rpf__qitem');
      if (first) first.focus();
    }
    closeQualityMenu() {
      if (!this.qMenu) return;
      this.qMenu.hidden = true;
      if (this.qBtn) this.qBtn.setAttribute('aria-expanded', 'false');
    }
    pickQuality(v) {
      this.quality = v;
      try { localStorage.setItem('svstk_reel_quality', v); } catch (e) {}
      this.updateQLabel();
      const reel = this.feedList && this.feedList[this.current];
      if (reel) this.buildQualityMenu(reel); // refresh the checkmark
      this.closeQualityMenu();
      if (this.qBtn) this.qBtn.focus();
      this.applyQualityToActive();
    }
    // Seamless live switch on the ACTIVE slide: keep time + play state across the src swap.
    applyQualityToActive() {
      const v = this.activeVideo();
      if (!v) return;
      const reel = this.feedList && this.feedList[this.current];
      const newSrc = this.srcFor(reel);
      if (!newSrc || v.getAttribute('src') === newSrc) return;
      const t = v.currentTime || 0;
      const wasPlaying = !v.paused;
      const onMeta = () => {
        v.removeEventListener('loadedmetadata', onMeta);
        try { v.currentTime = t; } catch (e) {}
        v.muted = this.muted;
        if (wasPlaying) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      };
      v.addEventListener('loadedmetadata', onMeta);
      v.setAttribute('src', newSrc);
      try { v.load(); } catch (e) {}
    }

    // Open the active reel on Instagram (its permalink; falls back to the brand IG profile).
    openInsta() {
      const reel = this.feedList && this.feedList[this.current];
      const url = this.sUrl((reel && reel.permalink) || this.igProfile || '#');
      if (url && url !== '#') window.open(url, '_blank', 'noopener');
    }
    toast(msg) {
      const el = this.querySelector('[data-rp-toast]');
      if (!el) return;
      el.textContent = msg; el.classList.add('is-shown');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(() => { el.classList.remove('is-shown'); }, 1800);
    }

    onClick(e) {
      const pop = e.target.closest('[data-rp-popular]');
      if (pop) { this.showPopular(); return; }
      const top = e.target.closest('[data-rp-top]');
      if (top) { this.scrollToIndex(0); return; }
      const capMore = e.target.closest('[data-rp-cap-more]');
      if (capMore) {
        const cap = capMore.closest('.rpf-slide__cap');
        if (cap) { const open = cap.classList.toggle('is-cap-open'); capMore.textContent = open ? 'less' : 'more'; capMore.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        return;
      }
      const toggle = e.target.closest('[data-rp-sheet-toggle]');
      if (toggle) {
        const rail = toggle.closest('.rpf-rail');
        if (rail) {
          const open = rail.classList.toggle('is-expanded');
          const bar = rail.querySelector('.rpf-bar');
          if (bar) bar.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.classList.toggle('rpf--sheet-open', open); // hides the floating action rail so it never overlaps the open sheet
        }
        return;
      }
      const add = e.target.closest('[data-rp-add]');
      if (add) { this.addToCart(add); return; }
      const inc = e.target.closest('[data-rp-qinc]');
      if (inc) { this.changeQty(inc.closest('.rpf-prod'), 1); return; }
      const dec = e.target.closest('[data-rp-qdec]');
      if (dec) { this.changeQty(dec.closest('.rpf-prod'), -1); return; }
      const chip = e.target.closest('[data-rp-chip]');
      if (chip) {
        const group = chip.closest('[data-opt-group]');
        if (group) { group.querySelectorAll('[data-rp-chip]').forEach((c) => c.classList.remove('is-sel')); chip.classList.add('is-sel'); }
        this.syncVariant(chip.closest('.rpf-prod'));
        return;
      }
      // Tap the video itself (not a control, link, or the scrubber) → toggle play/pause.
      if (e.target.closest('.rpf-slide__media') && !e.target.closest('a, button, [data-rp-scrub]')) this.togglePlay();
    }

    activeVideo() { const s = this.slides && this.slides[this.current]; return s ? s.querySelector('.rpf-slide__video') : null; }
    togglePlay() {
      const v = this.activeVideo();
      if (!v) return;
      if (v.paused) { const p = v.play(); if (p && p.catch) p.catch(() => {}); this.classList.remove('rpf--paused'); this.tickProgress(); }
      else { v.pause(); this.classList.add('rpf--paused'); }
    }
    // Smoothly drive the active slide's scrubber fill from the video clock (rAF, self-stops on pause).
    tickProgress() {
      cancelAnimationFrame(this._raf);
      const step = () => {
        if (this.hidden) return;
        const v = this.activeVideo();
        const s = this.slides && this.slides[this.current];
        if (v && s && v.duration) {
          const pct = Math.min(100, (v.currentTime / v.duration) * 100);
          const fill = s.querySelector('.rpf-scrub__fill'); if (fill) fill.style.width = pct + '%';
          const knob = s.querySelector('.rpf-scrub__knob'); if (knob) knob.style.left = pct + '%';
        }
        if (v && !v.paused) this._raf = requestAnimationFrame(step);
      };
      this._raf = requestAnimationFrame(step);
    }
    // Tap or drag the active slide's scrubber to seek. touch-action:none on the bar keeps this from scrolling the feed.
    onScrubStart(e) {
      const scrub = e.target.closest('[data-rp-scrub]');
      if (!scrub) return;
      const slide = scrub.closest('.rpf-slide');
      if (!slide || parseInt(slide.getAttribute('data-i'), 10) !== this.current) return;
      const v = this.activeVideo();
      if (!v) return;
      e.preventDefault();
      scrub.classList.add('is-drag');
      const bar = scrub.querySelector('.rpf-scrub__track');
      const fill = slide.querySelector('.rpf-scrub__fill');
      const knob = slide.querySelector('.rpf-scrub__knob');
      const seek = (clientX) => {
        const rect = bar.getBoundingClientRect();
        if (!rect.width || !v.duration) return;
        const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        v.currentTime = ratio * v.duration;
        if (fill) fill.style.width = (ratio * 100) + '%';
        if (knob) knob.style.left = (ratio * 100) + '%';
      };
      seek(e.clientX);
      const move = (ev) => seek(ev.clientX);
      const up = () => {
        scrub.classList.remove('is-drag');
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
      window.addEventListener('pointercancel', up);
    }

    // Caption starts collapsed to one line on every (re)activation; show the "more" toggle only when
    // the text is actually truncated (scrollHeight beats the clamped clientHeight). Measured
    // synchronously — the active slide is already laid out, so no rAF (which stalls in hidden tabs).
    syncCaption(slide) {
      const cap = slide.querySelector('.rpf-slide__cap');
      if (!cap) return;
      cap.classList.remove('is-cap-open');
      const h3 = cap.querySelector('h3');
      const more = cap.querySelector('[data-rp-cap-more]');
      if (more) { more.textContent = 'more'; more.setAttribute('aria-expanded', 'false'); }
      if (!h3) { cap.classList.remove('is-clamped'); return; }
      cap.classList.toggle('is-clamped', h3.scrollHeight > h3.clientHeight + 1);
    }

    // On mobile the product bar is pinned to the bottom; lift the caption to sit exactly above it
    // (measured, so single/multi bars + the safe-area inset are all handled). Desktop / no-bar → clear
    // the inline value so the caption sits at its CSS default (desktop bottom:0; mobile no-prods gets
    // the safe-area offset from .rpf-slide--noprods .rpf-slide__cap).
    positionCaption(slide) {
      const cap = slide.querySelector('.rpf-slide__cap');
      if (!cap) return;
      const mobile = window.matchMedia && window.matchMedia('(max-width: 759px)').matches;
      const rail = slide.querySelector('.rpf-rail');
      const bar = rail && rail.querySelector('.rpf-bar');
      if (mobile && bar) { cap.style.bottom = (rail.offsetHeight + 10) + 'px'; }
      else { cap.style.bottom = ''; }
    }

    changeQty(prod, delta) { if (!prod) return; const el = prod.querySelector('[data-rp-qval]'); let q = parseInt(el.textContent, 10) || 1; q = Math.max(1, q + delta); el.textContent = q; }

    /* Fetch each product in the active slide once and render inline size/variant chips (no "Details" digging,
       no description dump — the full description lives on the PDP via the "View full details" link). */
    hydrateSlide(slide) {
      if (!slide) return;
      slide.querySelectorAll('.rpf-prod').forEach((prod) => {
        if (prod._hydrated) return;
        const handle = prod.getAttribute('data-handle');
        if (!handle) return;
        prod._hydrated = true;
        this.fetchProduct(handle).then((data) => {
          if (!data) { prod._hydrated = false; return; }
          prod._product = data;
          this.renderOpts(prod, data);
        });
      });
    }
    renderOpts(prod, data) {
      const optsEl = prod.querySelector('[data-rp-opts]');
      if (!optsEl) return;
      const variants = data.variants || [];
      if (variants.length <= 1) { optsEl.hidden = true; return; } // nothing to choose
      let html = '';
      (data.options || []).forEach((opt, oi) => {
        const name = (opt && opt.name) ? opt.name : (typeof opt === 'string' ? opt : 'Option'); // /products/.js options are objects → use .name (fixes "[object Object]")
        const values = [...new Set(variants.map((v) => v['option' + (oi + 1)]))].filter((v) => v != null);
        if (values.length <= 1) return; // skip single-value options
        html += '<div class="rpf-opt" data-opt-group="' + oi + '"><span class="rpf-opt__label">' + this.esc(name) + '</span><div class="rpf-opt__chips">' +
          values.map((val, vi) => '<button type="button" class="rpf-chip' + (vi === 0 ? ' is-sel' : '') + '" data-rp-chip data-opt="' + oi + '" data-val="' + this.esc(val) + '">' + this.esc(val) + '</button>').join('') +
          '</div></div>';
      });
      optsEl.innerHTML = html;
      optsEl.hidden = !html;
      if (html) this.syncVariant(prod);
    }
    syncVariant(prod) {
      const data = prod && prod._product;
      if (!data) return;
      const chosen = (data.options || []).map((opt, oi) => {
        const sel = prod.querySelector('[data-opt-group="' + oi + '"] [data-rp-chip].is-sel');
        if (sel) return sel.getAttribute('data-val');
        const vals = [...new Set((data.variants || []).map((v) => v['option' + (oi + 1)]))];
        return vals.length ? vals[0] : null; // single-value option: take its only value
      });
      const match = (data.variants || []).find((v) => chosen.every((val, i) => val == null || v['option' + (i + 1)] === val));
      const btn = prod.querySelector('[data-rp-add]');
      const priceEl = prod.querySelector('[data-rp-price]');
      if (!match) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      if (btn) {
        btn.setAttribute('data-variant', match.id);
        if (match.available === false) { btn.disabled = true; btn.textContent = 'Sold out'; }
        else { btn.disabled = false; btn.textContent = 'Add to cart'; }
      }
      if (priceEl) priceEl.innerHTML = '<span>' + this.money(match.price) + '</span>' + (match.compare_at_price && match.compare_at_price > match.price ? '<del>' + this.money(match.compare_at_price) + '</del>' : '');
    }
    fetchProduct(handle) {
      if (this.productCache.has(handle)) return Promise.resolve(this.productCache.get(handle));
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => { this.productCache.set(handle, d); return d; })
        .catch(() => { this.productCache.set(handle, null); return null; });
    }

    addToCart(btn) {
      const variant = btn.getAttribute('data-variant');
      if (!variant || variant === '0') return;
      const prod = btn.closest('.rpf-prod');
      const qEl = prod && prod.querySelector('[data-rp-qval]');
      const qty = parseInt(qEl ? qEl.textContent : '1', 10) || 1;
      btn.disabled = true; btn.textContent = 'Adding…';
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: [{ id: Number(variant), quantity: qty }] } }));
      const reset = () => { btn.disabled = false; btn.textContent = 'Add to cart'; };
      const onAdded = (e) => {
        // If the drawer ever signals which variants were added, only complete the matching button
        // so a concurrent add can't flip this one early; otherwise fall back to the first signal.
        if (e && e.detail && e.detail.items && !e.detail.items.some((it) => Number(it.id) === Number(variant))) return;
        document.removeEventListener('cart:added', onAdded); clearTimeout(fb); btn.textContent = 'Added ✓'; setTimeout(reset, 1600);
      };
      document.addEventListener('cart:added', onAdded);
      const fb = setTimeout(() => { document.removeEventListener('cart:added', onAdded); reset(); }, 6000);
      const reels = this.feedList;
      this.track('atc', reels[this.current], { variant_id: String(variant), qty: qty });
    }

    showPopular() {
      const ids = this.popularIds();
      const inFeed = {};
      this.feedList.forEach((r) => { if (r) inFeed[r.id] = true; });
      const newReels = ids.map((id) => this.byId[id]).filter((r) => r && !inFeed[r.id]);
      if (!newReels.length) {
        const btn = this.trackEl.querySelector('[data-rp-popular]');
        if (btn) btn.hidden = true;
        return;
      }
      const firstNewIdx = this.feedList.length;
      this.feedList = this.feedList.concat(newReels);
      this.build();
      requestAnimationFrame(() => {
        if (this.slides[firstNewIdx]) { this.slides[firstNewIdx].scrollIntoView({ behavior: 'auto' }); this.setActive(firstNewIdx); }
      });
    }

    track(event, reel, data) {
      const ep = this.getAttribute('data-track-endpoint');
      if (!ep || !reel) return;
      const shop = (window.Shopify && Shopify.shop) || '';
      const body = JSON.stringify(Object.assign({ shop: shop, event: event, reel_id: reel.id }, data));
      try { navigator.sendBeacon(ep, new Blob([body], { type: 'text/plain' })); } catch (e) {}
    }
  }
  if (!customElements.get('svastika-reel-player')) customElements.define('svastika-reel-player', SvastikaReelPlayer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-clarity"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__svClarityInit) return;
  window.__svClarityInit = true;

  /* Never record theme-editor sessions — they are the merchant, not a shopper. */
  if (window.Shopify && window.Shopify.designMode) return;

  var PROJECT_ID = 'k5d74eff04';

  /* Real engagement signals only. mousemove is excluded on purpose (fires pre-LCP on cursor drift). */
  var TRIGGERS = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'];
  var LISTEN = { passive: true, capture: true };
  var started = false;

  function start() {
    if (started) return;
    started = true;

    for (var i = 0; i < TRIGGERS.length; i++) {
      window.removeEventListener(TRIGGERS[i], start, LISTEN);
    }

    /* Microsoft Clarity tag — vendor snippet, kept verbatim. t.async = 1 → never render-blocking. */
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", PROJECT_ID);
  }

  /* Path 1 — first real interaction wins: record from the first meaningful moment. */
  for (var i = 0; i < TRIGGERS.length; i++) {
    window.addEventListener(TRIGGERS[i], start, LISTEN);
  }

  /* Path 2 — no interaction: wait for load, then idle, so we never compete for first bytes. */
  function onIdle() {
    if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 3000 });
    else setTimeout(start, 1200);   /* Safari <16.4 has no requestIdleCallback */
  }
  if (document.readyState === 'complete') onIdle();
  else window.addEventListener('load', onIdle, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
